const destinations = [
  { name: "Barcelona", country: "Spain", flag: "🇪🇸", desc: "Top study abroad and tourism destination from NWA. UA students frequent this European gem." },
  { name: "Cancun", country: "Mexico", flag: "🇲🇽", desc: "Most popular spring break destination. Direct flights via Dallas make it a quick getaway." },
  { name: "London", country: "UK", flag: "🇬🇧", desc: "Business travel hub for Walmart international suppliers and UA exchange programs." },
  { name: "Tokyo", country: "Japan", flag: "🇯🇵", desc: "Growing destination for JB Hunt and Tyson Foods international business travel." },
  { name: "Patagonia", country: "Argentina/Chile", flag: "🇦🇷", desc: "Adventure travel hotspot for outdoor enthusiasts in the Ozarks community." },
  { name: "Cruise Ports", country: "Various", flag: "🚢", desc: "Galveston and New Orleans cruise ports are most popular from NWA families." },
];

export default function FayettevilleARDestinationsSection() {
  return (
    <section id="destinations" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Popular Destinations</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">Where Fayetteville, AR &amp; NWA Travelers Go</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {destinations.map((d, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 hover:border-[#F6C344] transition-all">
              <div className="flex items-center gap-3 mb-3">
                <span className="text-2xl">{d.flag}</span>
                <div><h3 className="font-bold text-[#1A365D] text-lg">{d.name}</h3><p className="text-gray-400 text-xs">{d.country}</p></div>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed">{d.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}